function t(r, o) {
  const i = { ...o };
  for (const n in i)
    i[n] = r.includes(n);
  return i;
}
export {
  t as array2Record
};
//# sourceMappingURL=index.js.map
